<div class="loading"><div class="dot-flashing"></div></div>